import request from '@/utilsCloud/request'
import port from './port'


export function employeeDetailIgnore(data) {
  return request({
    url: port.biz + '/employee/employeeDetailIgnore',
    headers: {
      isToken: false,
      isEntpId: false,
    },
    method: 'post',
    data: data
  })
}



export function getEmployeeStudyListIgnore(query) {
    return request({
      url: port.course + '/home/getEmployeeStudyListIgnore',
      headers: {
        isToken: false,
        isEntpId: false,
      },
      method: 'get',
      params: query
    })
  }
  


// WEBPACK FOOTER //
// ./src/apiCloud/linkUrl.js